<div class="requests-container">
  <div class="requests-container__header">
    <h1 class="heading-s">Requests</h1>
    <h3 class="body-m">Manage and track all customer requests</h3>
    <!-- <nav class="requests-nav" mat-tab-nav-bar [tabPanel]="tabPanel">
        <a
          class="body-m request-list-nav"
          id="requests-admin-nav"
          mat-tab-link
          [ngClass]="{ 'active-link': activeTab === 'requests' }"
          (click)="onRequestsClick()">Requests
        </a>
        <a
          class="body-m request-list-nav"
          id="requests-admin-nav"
          mat-tab-link
          [ngClass]="{ 'active-link': activeTab === 'expired' }">
          Expired</a>
    </nav> -->
    <div class="search-total-container">
      <span class="body-m total-records">{{totalRecords}} Requests</span>
      <div class="search-container">
        <mat-form-field appearance="fill">
          <mat-label>Search</mat-label>
          <mat-icon matSuffix>search</mat-icon>
          <input matInput (keyup)="applyFilter($event)" placeholder="Search" />
        </mat-form-field>
      </div>  
    </div>  
  </div>
  <mat-tab-nav-panel #tabPanel>
  <table
    [dataSource]="dataSource"
    aria-label="This table displays the requests"
    mat-table
    matSort
    multiTemplateDataRows>

    <ng-container matColumnDef="number">
      <th *matHeaderCellDef mat-header-cell mat-sort-header="number">
          Number
      </th>
      <td
        *matCellDef="let request"
        [class.disable-col]="request.statusCode === RequestStatusV2.expired"
        mat-cell>
        <div class="body-m-bold">
          {{ request.id }}
        </div>
      </td>
    </ng-container>

    <ng-container matColumnDef="company">
      <th *matHeaderCellDef mat-header-cell mat-sort-header="company">
          Company
      </th>
      <td
        *matCellDef="let request"
        [class.disable-col]="request.statusCode === RequestStatusV2.expired"
        mat-cell>
        <div class="body-m-bold">
          {{ request.company?.name }}
        </div>
      </td>
    </ng-container>

    <ng-container matColumnDef="status">
      <th *matHeaderCellDef mat-header-cell mat-sort-header>
        Status
      </th>
      <td
        *matCellDef="let request"
        [attr.colspan]="1"
        mat-cell>
        <div
        [class.disable-col]="request.statusCode === RequestStatusV2.expired"
        class="current-status">
        <app-chip [text]="'back-office-status.' + request.status | translate"
        [type]="getStatusType(request.status)" 
        [disabled]="request.status === RequestStatusV2.expired">
        </app-chip>
      </div>
      </td>
    </ng-container>

    <ng-container matColumnDef="date">
      <th *matHeaderCellDef mat-header-cell mat-sort-header="createdAt">
          Creation date
      </th>
      <td
        *matCellDef="let request"
        [class.disable-col]="request.statusCode === RequestStatusV2.expired"
        class="body-m date-cell"
        mat-cell>
        {{ request.createdAt | date : 'dd/MM/yyyy - HH:mm' }}
      </td>
    </ng-container>

    <ng-container matColumnDef="goto-request">
      <th *matHeaderCellDef mat-header-cell>&nbsp;</th>
      <td *matCellDef="let request" class="body-m link-cell" mat-cell>
        <app-button 
        [routerLink]="['/admin/request/details/', request.id, request.endUses?.[0]?.id]"
        type="tertiary" size="small" text="Open" icon="arrow_forward">
        </app-button>
      </td>
    </ng-container>

    <tr *matHeaderRowDef="displayedColumns; sticky: true" mat-header-row></tr>
    <tr
      *matRowDef="let element; columns: displayedColumns"
      mat-row></tr>
  </table>
  </mat-tab-nav-panel>
  @if ((adminService.requests()?.pagination?.totalPage ?? 0) > 1) {
    <app-pagination [currentPage]="currentPage" [totalPages]="adminService.requests()?.pagination?.totalPage ?? 0" (pageChange)="onPageChange($event)"></app-pagination>
  }
</div>